const data = {
  products: [
    {
      id: "1",
      name: "Polar Skate Co Devil T Shirt",
      price: 1400,
      image: "./images/pic1.png",
    },
    {
      id: "2",
      name: "Polar Skate Co Devil T Shirt",
      price: 2400,
      image: "./images/pic2.png",
    },
    {
      id: "3",
      name: "Polar Skate Co Devil T Shirt",
      price: 1000,
      image: "./images/pic3.png",
    },
    {
      id: "4",
      name: "Polar Skate Co Devil T Shirt",
      price: 1200,
      image: "./images/pic4.png",
    },
  ],
};
export default data;
